import React from 'react'
import Commoninformation from '../Pagehome/Commoninformation'
import { Link } from 'react-router-dom'
import Icons from '../../components/icons';

const Advertisewithus = () => {
    return (
        <>
            {/* <Commoninformation /> */}
            <div className='container-lg'>
                {/*breadcrunb start*/}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                            <Link to="/">Home</Link>
                        </li>
                        <li><span><Icons.SlashSvg /></span></li>
                        <li className="breadcrumb-item active" aria-current="page">
                            Advertise With Us
                        </li>
                    </ol>
                </nav>
                {/*breadcrunb End*/}
            </div>
            <div className='innerpages-section padding-50'>
                <div className='container-lg'>

                    <div className='flex-box justify-center mb-4'>
                        <div className='custom-heading  text-center '>
                            Advertise With Us
                        </div>
                    </div>

                    <div className='inp-inner'>

                        <div className='custom-heading ch-medium'>Promote Your Business Forbes</div>
                        <div className='custom-text ct-small'>
                            <strong>Showcase your organization through Forbes</strong> and reach a discerning audience across the <strong>United Kingdom</strong>. Our platform delivers credible updates, giving brands an opportunity to connect with readers who value insightful content.
                        </div>

                        <div className='custom-heading ch-medium'>Why Collaborate with Forbes?</div>
                        <ul className='custom-text ct-small custom-list-style'>
                            <li><strong>Focused UK Audience:</strong> Engage readers interested in <strong>finance, business, lifestyle, culture, and UK developments</strong>.</li>
                            <li><strong>Enhanced Brand Exposure:</strong> Feature your organization via banners, sponsored content, and multimedia placements.</li>
                            <li><strong>Tailored Campaigns:</strong> Options include online ads, editorial-style articles, and social media integration.</li>
                            <li><strong>SEO-Optimized Reach:</strong> Improve your visibility naturally on search engines.</li>
                            <li><strong>Trusted Platform Alignment:</strong> Associate your brand with a reputable UK-focused media source.</li>
                        </ul>

                        <div className='custom-heading ch-medium'>Advertising Options</div>
                        <ul className='custom-text ct-small custom-list-style'>
                            <li><strong>Banner Placements:</strong> High-visibility positions across web pages</li>
                            <li><strong>Sponsored Articles:</strong> Editorial-style stories highlighting your services</li>
                            <li><strong>Video Features:</strong> Short clips embedded in content to boost engagement</li>
                            <li><strong>Newsletter Highlights:</strong> Reach active subscribers regularly</li>
                        </ul>

                        <div className='custom-text ct-small'>
                            For inquiries or partnership opportunities, contact:
                        </div>
                        <div className='custom-text ct-small'>
                            Email: <a href="mailto:advertise@forbes.news" className="external-link"><strong>advertise@forbes.news</strong></a>
                        </div>
                        <div className='custom-text ct-small'>
                            Or submit requests through our <strong>Contact Page</strong><br/>
                            <span style={{fontWeight: 'bold'}}>Increase visibility, engage UK readers, and elevate your brand presence with </span>
                            <Link to="/" className="external-link" >forbes.com</Link>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}

export default Advertisewithus